function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M29 15C29 22.732 22.732 29 15 29C7.26801 29 1 22.732 1 15C1 7.26801 7.26801 1 15 1C22.732 1 29 7.26801 29 15Z",
  stroke: "var(--n-color-text-dark)",
  strokeWidth: 0.6
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8226 20.7422H11.1774C10.1209 20.7422 9.25781 19.8791 9.25781 18.8226V11.1774C9.25781 10.1209 10.1209 9.25781 11.1774 9.25781H18.8226C19.8791 9.25781 20.7422 10.1209 20.7422 11.1774V18.8226C20.7422 19.8838 19.8838 20.7422 18.8226 20.7422Z",
  stroke: "var(--n-color-text-dark)",
  strokeWidth: 0.6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9177 17.087C13.4743 17.6435 14.2147 17.9501 15.0024 17.9501C15.79 17.9501 16.5258 17.6435 17.087 17.087C17.6435 16.5305 17.9501 15.79 17.9501 15.0024C17.9501 14.2147 17.6435 13.4743 17.087 12.9177C16.5305 12.3612 15.79 12.0546 15.0024 12.0546C14.2147 12.0546 13.4743 12.3612 12.9177 12.9177C12.3612 13.4743 12.0546 14.2147 12.0546 15.0024C12.0546 15.79 12.3612 16.5305 12.9177 17.087Z",
  stroke: "var(--n-color-text-dark)",
  strokeWidth: 0.6
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5247 11.9578C18.8372 11.9578 19.0906 11.7044 19.0906 11.3918C19.0906 11.0792 18.8372 10.8258 18.5247 10.8258C18.2121 10.8258 17.9587 11.0792 17.9587 11.3918C17.9587 11.7044 18.2121 11.9578 18.5247 11.9578Z",
  stroke: "var(--n-color-text-dark)",
  strokeWidth: 0.6
});

function SvgIconSocialInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialInstagram);
export default __webpack_public_path__ + "static/media/icon-social-instagram.7f6c3415601a457d84b13bd76a149869.svg";
export { ForwardRef as ReactComponent };